var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 3.81607V1.3334C14.6667 0.965404 14.3687 0.666737 14 0.666737C13.6313 0.666737 13.3333 0.965404 13.3333 1.3334V2.91074L9.86467 0.57007C8.732 -0.19393 7.268 -0.19393 6.13533 0.57007L1.46867 3.7194C0.549333 4.34007 0 5.37274 0 6.48274V12.6667C0 14.5047 1.49533 16.0001 3.33333 16.0001H4.66667C5.03533 16.0001 5.33333 15.7014 5.33333 15.3334V9.3334C5.33333 8.96607 5.632 8.66674 6 8.66674H10C10.368 8.66674 10.6667 8.96607 10.6667 9.3334V15.3334C10.6667 15.7014 10.9647 16.0001 11.3333 16.0001H12.6667C14.5047 16.0001 16 14.5047 16 12.6667V6.48274C16 5.42874 15.504 4.44407 14.6667 3.81607Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.0e69fe05307314c9fbf90a72c4e0130b.svg";
export { ForwardRef as ReactComponent };